<header>
  <!-- LOGO -->
  <div class="logo">
    <a routerLinkActive="active-link" (click)="goHome()">
      <img src="assets/images/header-logo.png" [alt]="'routes.header.logo' | translate" />
    </a>
  </div>
  <!-- NAVIGATION -->
  <nav>
    <ul>
      <!-- <li class="route-planner">
        <a matButton="filled" routerLink="/routes/via-verde-1" routerLinkActive=" active-link">{{ 'header.route' |
          translate }}</a>
      </li> -->
      <li>
        <a class="language" mat-button [matMenuTriggerFor]="languageMenu">
          <span>{{ 'languages.' + actualLanguage()?.code| translate }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </a>
      </li>
    </ul>
  </nav>
</header>

<!-- LANGUAGE MENU -->
<mat-menu #languageMenu="matMenu">
  @for (language of languages(); track $index) {
  <button type="button" (click)="changeLanguage(language)" mat-menu-item>
    <span>{{ 'languages.' + language.code | translate }}</span>
  </button>
  }
</mat-menu>

<!-- PROFILE MENU -->